module.exports = __webpack_public_path__ + "static/media/machobanners_sm2.b94d20c5.png";